import React from "react";
import config from "../../config/config";
import Sidebar from "./Sidebar";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import DashboardHeader from "./directives/DashboardHeader";
import "./css/Dashboard.css";
import "./css/Custom.css";
import DataTable from "react-data-table-component";



const Project = ({ special, clearModalData }) => {
  const AMEAllocation = () => {
    window.location.href = `${config.baseUrl}projectoverview`; // Replace with your desired URL
  };

  return (
    <>
      <div className="w-100 d-grid" style={{ minHeight: "100vh", overflow: "hidden" }}>
        <div className="d-flex  w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: "1px solid rgba(255, 255, 255, 0.15)" }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: "100%" }}>
            <DashboardHeader />
            <div
              className="px-4 px-lg-4"
              style={{
                // padding: "15px",
                flex: "1",
                backgroundColor: "#00021F",
                color: "#ffffff",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Row className="">
                <Col xxl={12}>
                  <div className="heading py-4">
                    <h5 className="mb-0">Staking</h5>
                  </div>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Axverse</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Vima Network</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                         
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Grand Protocol</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col xxl={12}>
                  <div className="heading pb-4">
                    <h5 className="mb-0">Coming Soon</h5>
                  </div>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Axverse</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Vima Network</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                  <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
                    <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                      <img
                        src="assets/images/shape/boxshade.png"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <Card.Body className="p-0 position-relative">
                      <h4 className="text-white">Grand Protocol</h4>
                      <div className="my-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Total Raise
                          </div>
                          <div className="mb-2 text-white small">$250,000</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">
                            Token Price
                          </div>
                          <div className="mb-2 text-white small">$0.521</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Start Date</div>
                          <div className="mb-2 text-white small">TBA</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mb-2 text-light-grey small">Type</div>
                          <div className="mb-2 text-white small">Standard IDO</div>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <Button
                          variant="primary-gradient"
                          className="w-100 border-0 px-md-1 small"
                          onClick={AMEAllocation}
                        >
                          AME Allocation
                        </Button>
                        <Button
                          variant="outline-blue"
                          className="w-100 px-md-1 small"
                        >
                          Fixed Allocation
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Project;
